import { createApiRef } from '@backstage/core-plugin-api';

export const OnboardSquadsApiRef = createApiRef<OnboardSquadsApi>({
  id: 'plugin.onboardsquads.service',
});

export interface OnboardSquadsApi {
  addUserToSquad(
    userToken: string,
    filePath: string,
    memberEntity: string,
  ): Promise<{ message: string; prUrl: string }>;

  deleteUserFromSquad(
    userToken: string,
    filePath: string,
    memberEntity: string,
  ): Promise<{ message: string; prUrl: string }>;
}
